var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{staticClass:"dialog",attrs:{"value":_vm.open,"max-width":"600px"},on:{"input":_vm.closeDialog}},[_c('v-card',[_c('a',{attrs:{"href":"https://bit.ly/37SY31Q","target":"_blank"}},[_c('v-img',{attrs:{"height":"250","src":require("@/assets/firmNewPP.png")}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }